import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../Context';
import s from './StageContainer.scss';
const StageContainer = /*#__PURE__*/ forwardRef(({ withoutInnerWrapper, className, children }, ref)=>{
    const { isTheater, isFullscreen } = useDeviationViewContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], className),
        ref: ref
    }, withoutInnerWrapper && children, !withoutInnerWrapper && /*#__PURE__*/ React.createElement("div", {
        className: s['stage-content']
    }, children));
});
StageContainer.displayName = 'StageContainer';
export default StageContainer;

//# sourceMappingURL=StageContainer.js.map